module.exports = __webpack_public_path__ + "08aa8b2b7f3f4793d02518927dacfe54.png";